// @mui
import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import type { ImageProps } from './types';

//
import getRatio from './getRatio';

// ----------------------------------------------------------------------

const Image = forwardRef<HTMLSpanElement, ImageProps>(
  ({ disabledEffect = false, effect = 'blur', ratio, sx, ...other }, ref) => {
    const content = (
      <Box
        component={LazyLoadImage}
        effect={disabledEffect ? undefined : effect}
        placeholderSrc={
          disabledEffect ? '/assets/transparent.png' : '/assets/placeholder.svg'
        }
        sx={{ height: 1, objectFit: 'cover', width: 1 }}
        wrapperClassName="wrapper"
        {...other}
      />
    );

    if (ratio) {
      return (
        <Box
          component="span"
          ref={ref}
          sx={{
            '& .wrapper': {
              backgroundSize: 'cover !important',
              height: 1,
              left: 0,
              position: 'absolute',
              top: 0,
              width: 1,
            },
            display: 'block',
            lineHeight: 1,
            overflow: 'hidden',
            position: 'relative',
            pt: getRatio(ratio),
            width: 1,
            ...sx,
          }}
        >
          {content}
        </Box>
      );
    }

    return (
      <Box
        component="span"
        ref={ref}
        sx={{
          '& .wrapper': {
            backgroundSize: 'cover !important',
            height: 1,
            width: 1,
          },
          display: 'block',
          lineHeight: 1,
          overflow: 'hidden',
          position: 'relative',
          ...sx,
        }}
      >
        {content}
      </Box>
    );
  }
);

Image.displayName = 'Image';

export default Image;
